import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import { OnboardingStepperHeaderIcon } from "@src/components/MainApp/Onboarding/components/OnboardingStepperHeaderIcon";

interface OnboardingHeaderStepperProps {
  currentStep: number;
}

const steps = ["About You", "Your Store", "Goals", "Additional Info"];

export const OnboardingHeaderStepper = ({
  currentStep,
}: OnboardingHeaderStepperProps) => {
  return (
    <Stack spacing={8} direction={"column"}>
      <LinearProgress variant={"determinate"} value={(currentStep + 1) * 25} />

      <Grid container direction={"row"} justifyContent={"space-between"}>
        {steps.map((label, index) => (
          <Grid key={index}>
            <Stack
              direction={"column"}
              alignItems={"center"}
              textAlign={"center"}
              spacing={2}
            >
              <OnboardingStepperHeaderIcon
                sx={{ fontSize: "32px" }}
                active={currentStep === index}
                completed={currentStep > index}
              />

              <IgTypography>{label}</IgTypography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
